import { render, staticRenderFns } from "./OperatsiyaChek.vue?vue&type=template&id=dc0f4c8e"
import script from "./OperatsiyaChek.vue?vue&type=script&lang=js"
export * from "./OperatsiyaChek.vue?vue&type=script&lang=js"
import style0 from "./OperatsiyaChek.vue?vue&type=style&index=0&id=dc0f4c8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports